// Translation for sv
export const sv = {
        common: {
            save: 'Spara',
            cancel: 'Avbryt',
            close: 'Stäng',
            delete: 'Radera',
            edit: 'Redigera',
            activate: 'Aktivera',
            add: 'Lägg till',
            saving: 'Sparar...',
            loading: 'Laddar...',
            active: 'AKTIV',
            inUse: 'I Bruk',
            test: 'Test',
            searchApps: 'Sök appar...',
            betaBanner: 'BETA - Tjänsten är inte tillgänglig än!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Logga In',
            signUp: 'Registrera',
            username: 'Användarnamn',
            password: 'Lösenord',
            continue: 'Fortsätt',
            noAccount: 'Har du inget konto?',
            hasAccount: 'Har du redan ett konto?',
            loginError: 'Inloggningen misslyckades',
            invalidCredentials: 'Ogiltigt användarnamn eller lösenord',
            rateLimited: 'För många inloggningsförsök. Vänta en stund.',
            sessionExpired: 'Din session har upphört. Använd en ny magisk länk.',
            magicLinkInvalid: 'Inloggningslänken är ogiltig eller upphörd.',
            magicLinkSuccess: 'Välkommen! Du har loggats in.',
            magicLinkProcessing: 'Behandlar inloggning...',
            connectionError: 'Anslutningsfel. Försök igen.'
        },
        profile: {
            myProgress: 'Min Inlärningsframgång',
            signOut: 'Logga Ut',
            plan: 'Plan: '
        },
        settings: {
            title: 'Inställningar',
            tabs: {
                uiSettings: 'UI-inställningar',
                systemPrompt: 'Systemprompt',
                llmProfiles: 'LLM-profiler',
                ttsProfiles: 'TTS-profiler',
                language: 'Språk',
            },
            uiSettings: {
                title: 'Användargränssnitt',
                themeMode: 'Temaläge',
                darkMode: 'Mörkt Läge',
                lightMode: 'Ljust Läge',
                themeColor: 'Temafärg',
                themeColorDesc: 'Välj accentfärg för knappar, ikoner och markeringar',
                background: 'Bakgrund',
                backgroundDesc: 'Välj en bakgrund för din arbetsyta',
                selectBackgroundColor: 'Välj Bakgrundsfärg',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Fokus',
                    concentration: 'Koncentration',
                    relaxation: 'Avslappning',
                    lianas: 'Lianer',
                    color: 'Färg'
                },
                backgroundColors: {
                    deepDark: 'Djupt Svart',
                    darkGrey: 'Mörkgrå',
                    midnightBlue: 'Midnattsblå',
                    indigo: 'Indigo',
                    darkTeal: 'Mörk Teal',
                    brown: 'Brun',
                    darkRed: 'Mörkröd',
                    deepPurple: 'Djup Lila',
                    pureWhite: 'Rent Vitt',
                    softWhite: 'Mjukt Vitt',
                    lightGrey: 'Ljusgrå',
                    paleBlue: 'Blekt Blå',
                    paleGreen: 'Blekt Grön',
                    paleOrange: 'Blekt Orange',
                    lavender: 'Lavendel',
                    blueGrey: 'Blågrå'
                }
            },
            systemPrompt: {
                label: 'Systemprompt:',
                placeholder: 'Laddar systemprompt...',
                emptyError: 'Systemprompten kan inte vara tom!',
                saveSuccess: '✓ Systemprompten sparades!',
                loadError: 'Fel vid inläsning av systemprompten',
                saveError: 'Fel vid sparande'
            },
            llmProfiles: {
                addButton: '+ Lägg Till Ny Anslutning',
                newConnection: 'Ny Anslutning',
                editConnection: 'Redigera Anslutning',
                emptyState: 'Inga LLM-anslutningar tillgängliga. Klicka nedan för att lägga till en.',
                loadingProfiles: 'Laddar profiler...',
                nameLabel: 'Namn *',
                namePlaceholder: 't.ex. OpenAI GPT-4',
                apiUrlLabel: 'API-URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API-nyckel *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Modell *',
                modelPlaceholder: 'gpt-4, mistral-tiny, osv.',
                allFieldsRequired: 'Alla fält måste fyllas i!',
                saveSuccess: '✓ Profilen sparades!',
                deleteConfirm: 'Vill du verkligen ta bort "{name}"?',
                profileNotFound: 'Profil hittades inte!',
                loadError: 'Fel vid inläsning av profiler',
                saveError: 'Fel vid sparande',
                activateError: 'Fel vid aktivering',
                deleteError: 'Fel vid borttagning',
                modelInfo: 'Modell: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Lägg Till Ny Röst',
                newVoice: 'Ny Röst',
                editVoice: 'Redigera Röst',
                emptyState: 'Inga TTS-profiler tillgängliga. Klicka nedan för att lägga till en.',
                loadingProfiles: 'Laddar TTS-profiler...',
                nameLabel: 'Namn',
                namePlaceholder: 't.ex. Min ElevenLabs Adam',
                providerLabel: 'Leverantör',
                providerPlaceholder: 't.ex. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Lokal)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API-URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API-nyckel *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Modell-ID *',
                modelIdPlaceholder: 't.ex. eleven_monolingual_v1',
                voiceIdLabel: 'Röst-ID',
                voiceIdPlaceholder: 't.ex. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Alla fält måste fyllas i!',
                saveSuccess: '✓ TTS-profilen sparades!',
                deleteConfirm: 'Vill du verkligen ta bort "{name}"?',
                loadError: 'Fel vid inläsning av TTS-profiler',
                saveError: 'Fel vid sparande',
                activateError: 'Fel vid aktivering',
                deleteError: 'Fel vid borttagning'
            },
            language: {
                title: 'Välj Språk',
                description: 'Välj ditt föredragna språk för användargränssnittet'
            },
        },
        chat: {
            ready: 'Klar',
            start: 'STARTA',
            stop: 'STOPP',
            initialMessage: 'Klicka STARTA för realtidskonversation.',
            listening: 'Lyssnar...',
            speaking: 'Thorsten talar...',
            userLabel: 'Du',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Skriv ett meddelande...',
            send: 'Skicka',
            loginRequired: 'Logga in för att använda denna tjänst.',
            loginButton: 'Logga In Nu',
            magicLinkRequired: 'Använd en magisk länk för att logga in.',
            creditLimitError: 'Din timkvot är förbrukad. Uppgradera din plan (Medium/Premium) för att fortsätta.',
            serviceDisabled: 'Chatttjänsten är för närvarande inte tillgänglig. Försök igen senare.'
        },
        notifications: {
            error: 'Fel',
            success: 'Framgång',
            info: 'Information',
            unknownError: 'Ett okänt fel inträffade'
        },
        cookie: {
            message: 'Den här webbplatsen använder cookies för att ge dig bästa möjliga användarupplevelse.',
            accept: 'Acceptera'
        },
        curriculum: {
                buttonLabel: 'Läroplan',
                buttonTitle: 'Visa läroplansinnehåll',
                modalTitle: '{app} Läroplan',
                sections: {
                    topic: 'Läroplanstema',
                    explanation: 'Barnvänlig förklaring',
                    studentProfile: 'Elevprofil'
                },
                topic: {
                    empty: 'Inget läroplanstema är kopplat till denna mikroapp i backend.',
                    missingDetail: 'Detaljerad läroplansdata för denna mikroapp är ännu inte tillgänglig i backend.',
                    learningGoals: 'Lärandemål',
                    prerequisites: 'Förkunskaper',
                    unitLabel: 'Enhet',
                    durationLabel: 'Varaktighet',
                    difficultyLabel: 'Svårighetsgrad',
                    hours: 'tim',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Ingen barnvänlig förklaring tillgänglig.',
                    loadingPrepare: 'AI förbereder förklaringen',
                    loadingExplain: 'AI förklarar ämnet på barnvänligt språk',
                    requestFailed: 'Barnvänlig förklaring kunde inte genereras.'
                },
                studentProfile: {
                    country: 'Land',
                    region: 'Stat / Region',
                    schoolType: 'Skoltyp',
                    grade: 'Årskurs',
                    noContext: 'Ingen elevkontext tillgänglig.',
                    childProfileNotFound: 'Ingen elevprofil hittades i backend för den aktuella inloggningen.',
                    loginProfileIncomplete: 'Inloggningsprofilen innehåller ännu inte en fullständig elevkontext.',
                    educationContextNotFound: 'En elevprofil hittades, men ingen läroplanskoppling är inställd.',
                    noToken: 'Ingen inloggad elev hittades.'
                },
                errors: {
                    signInRequired: 'Logga in för att se läroplanen.',
                    appIdMissing: 'App-ID saknas.',
                    loadFailed: 'Kunde inte ladda läroplansdata.'
                }
            }
    };
